enum AnnotationEditBoxDialogFields {
	WIDTH = "width",
	HEIGHT = "height",
	LEFT = "left",
	TOP = "top",
}

export default AnnotationEditBoxDialogFields;